import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const ScaleIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      id='fi_2780188' enable-background='new 0 0 512 512' viewBox='0 0 512 512' fill={theme.palette.text.primary}
      height={props.width} width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          d='m420.35 133.783c-2.023-3.543-4.511-6.009-8.34-7.37l-111.02-40.41c.42-12.06-3.95-24.25-13.14-33.43-18.905-18.916-50.485-17.402-67.35 4.13l-110.85-40.34c-.01-.01-.02-.01-.02-.01-7.765-2.774-15.589 1.337-18.51 7.35l-70.25 139.5h33.59l50.13-99.56 50.74 99.56h33.67l-53.83-105.63 75.8 27.59c.311 19.272 12.623 35.58 30.03 41.74v291.34c0 8.28 6.72 15 15 15s15-6.72 15-15v-291.34c7.307-2.574 13.876-7.006 19.02-12.97l95.94 34.92-63.15 125.45h33.59l50.55-100.42 50.59 100.42h33.59zm-153.71-38.72c-5.87 5.87-15.41 5.87-21.28 0s-5.87-15.41 0-21.28 15.41-5.87 21.28 0c5.879 5.879 5.889 15.391 0 21.28z'
        />
        <path
          d='m273.662 404.243h-35.323c-42.617 0-77.289 34.671-77.289 77.288 0 8.284 6.716 15 15 15h159.9c8.284 0 15-6.716 15-15 0-42.617-34.671-77.288-77.288-77.288z'
        />
        <path
          d='m497 304.299h-180.05c-8.284 0-15 6.716-15 15 0 57.911 47.114 105.025 105.025 105.025s105.025-47.114 105.025-105.025c0-8.284-6.716-15-15-15z'
        />
        <path
          d='m195.1 193.205h-180.1c-8.284 0-15 6.716-15 15 0 57.925 47.125 105.05 105.05 105.05s105.05-47.125 105.05-105.05c0-8.284-6.716-15-15-15z'
        />
      </g>
    </svg>
  )
}
export default ScaleIcon
